/*jslint browser */
/*global process */

var $ = jQuery;

/**
 *
 */
export default class IdGenerator
{
    public generate(): string {
        return Date.now().toString(36) + Math.random().toString(36).substr(2)
    }
}